import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { DataService } from '../../services/data.service';
import * as FileSaver from 'file-saver';
import { FrontEndService } from '../../services/front-end.service';
import { empty } from 'rxjs/observable/empty';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {
  loading = false;
  modalRef: NgbModalRef;
  closeResult: any;
  showErrorValid = false;
  user_id = this.dataService.userDetails['user_id'];
  emailInput = [''];
  the_number = 0;
  emailChecked = false;

  @ViewChild("downloadModelContent") private downloadModelContent: ElementRef;
  @ViewChild("filterModal") filterModal;
  @Input("filter") filter;

  downloadForm = {
    'downloadFormat': 'csv',
    'email': false,
    'downloadFile': true
  };

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private dataService: DataService,
    private frontEndService: FrontEndService,
    private logService: LogService
  ) { }

  ngOnInit() {
  }

  downloadTransaction() {
    this.logService.printLog("Download check -", this.downloadForm);
    // this.logService.printLog('Email array', this.emailInput);

    this.downloadForm['user_id'] = this.dataService.userDetails['user_id'];
    this.downloadForm['code_type'] = this.filter['code_type'].toString();
    this.downloadForm['is_rated_applied'] = this.filter.isRatedApplied;
    this.downloadForm['is_external_applied'] = this.filter.isExternalDBApplied;

    if (this.filter.isExternalDBApplied) {
      this.downloadForm['is_external'] = this.filter.externalDB ? 1 : 0;
    }

    if (this.filter.isRatedApplied) {
      this.downloadForm['is_rated'] = this.filter.isRated ? 1 : 0;
    }

    if (this.filter.isDateApplied) {
      this.downloadForm['date_to'] = this.formatDate(this.filter['dateTo']);
      this.downloadForm['date_from'] = this.formatDate(this.filter['dateFrom']);
    }

    this.emailChecked = this.downloadForm['email'];

    if (!this.downloadForm['downloadFile'] && !this.downloadForm['email']) {
      this.showErrorValid = true;
    } else {
      let isEmailValid = true;
      console.log('Email Input', this.emailInput);
      this.emailInput.forEach(element => {
        // console.log('Element', typeof element);
        if (element === null || element.trim() === "") {
          isEmailValid = false;
        }
      });

      console.log('isEmailValid', isEmailValid);

      if (isEmailValid) {
        if (this.downloadForm.downloadFile) {
          this.downloadForm['email'] = false;
          this.loading = true;
          this.apiService.downloadTransactions(this.downloadForm, this.downloadCallback);
          this.loading = false;
        } else {
          this.emailTransactions();
        }
      }
      this.showErrorValid = false;
    }
  }

  formatDate(dateObject) {
    // this.logService.printLog("Date object - ", dateObject);
    let month = dateObject.month;
    let day = dateObject.day;
    if (dateObject.month < 10) {
      month = "0" + dateObject.month;
    }

    if (dateObject.day < 10) {
      day = "0" + dateObject.day;
    }
    return dateObject.year + "-" + month + "-" + day;
  }

  downloadCallback = (response) => {

    // this.logService.printLog('Download Response', response);
    this.loading = false;
    this.frontEndService.addToast('Success', "Download successfully", 'success');
    this.downloadFile(response);

    if (this.emailChecked) {
      this.emailTransactions();
    } else {
      this.resetForm();
    }
  }

  emailTransactions() {
    this.downloadForm['email'] = true;
    this.downloadForm['emailFields'] = this.emailInput.toString();
    let isAllEmail: boolean = true;
    // console.log("emailinput", this.emailInput);
    // console.log('isAllEmail', isAllEmail);
    if (this.downloadForm['email'] && isAllEmail) {
      this.logService.printLog("email is true", "")
      this.loading = true;
      this.apiService.emailTransactions(this.downloadForm, this.emailCallBack);
      this.showErrorValid = false;
    } else {
      this.logService.printLog("email is not true", "");
    }

  }

  emailCallBack = (response) => {
    this.loading = false;
    this.frontEndService.addToast('Success', "Email sent successfully", 'success');
    this.resetForm();
  }

  resetForm() {
    this.downloadForm = {
      'downloadFormat': 'csv',
      'email': false,
      'downloadFile': true
    };
    this.emailInput = [''];
    this.emailChecked = false;
    this.closeModal();
  }

  downloadFile(data: Response) {
    let fileExtension = 'csv';
    let blob = new Blob([data], { type: 'text/csv' });

    if (this.downloadForm['downloadFormat'] === 'xl') {
      fileExtension = 'xls';
      blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    }
    if (this.downloadForm['downloadFormat'] === 'pdf') {
      fileExtension = 'pdf';
      blob = new Blob([data], { type: 'application/pdf' });
    }
    FileSaver.saveAs(blob, 'transaction.' + fileExtension);
  }

  closeModal() {
    this.modalRef.close();
  }

  open() {
    this.modalRef = this.modalService.open(this.downloadModelContent);
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  addEmail() {
    this.the_number += 1;
    this.emailInput.push('');
  }

  removeEmail(email_field) {
    const index = this.emailInput.indexOf(email_field);
    this.emailInput.splice(index, 1);
  }

  trackByFn(index: any, item: any) {
    return index;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/download/download.component.ts